<template>
    <page :title="$t('widgetmaker_main_title')" :breadcrumb="[]" :full="false">
        <!--<h1>{{ $t('widgetmaker_main_title') }}</h1>-->
        <div class="row">
            <div class="col-md-12 col-lg-12">
                <div class="listing-detail-section" id="listing-detail-section-description" data-title="Description">
                    <h4>{{ $t('widgetmaker_intro') }}</h4>

                    <div class="row">
                        <div class="col-lg-6">
                            <div class="overview">
                                <h2>{{ $t('widgetmaker_landing_head') }}</h2>
                                <p>
                                    {{ $t('widgetmaker_landing_intro') }}
                                </p>
                            </div>
                            <div class="form-group">
                                <label>{{ $t('widgetmaker_landing_lang') }}</label>

                                <select class="form-control" v-model="landingLanguage">
                                    <option v-for="lang in languages" :key="lang.id" :value="lang.id">
                                        {{lang.languagename}}
                                    </option>
                                    <option value="auto">{{ $t('widgetmaker_landing_lang_auto') }}</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>{{ $t('widgetmaker_landing_theme') }}</label>
                                <div v-for="theme in themes" :key="theme.name"
                                     :class="{'colorPicker':true, selPicker: theme.name === landingTheme}"
                                     :style="`background-color: ${theme.color}`"
                                     @click="clkTheme(theme.name)"
                                >
                                </div>
                                <div style="clear:both;"></div>
                            </div>
                            <div class="form-group">
                                <a :href="landingURL" target="_blank"><b>{{ $t('widgetmaker_landing_preview') }}</b></a>
                            </div>
                            <!-- /.overview -->
                        </div>
                        <!-- /.col-* -->
                        <div class="col-lg-6">
                            <div class="overview">
                                <h2>{{ $t('widgetmaker_button_head') }}</h2>
                            </div>
                            <div class="form-group">
                                <label>{{ $t('widgetmaker_button_color_label') }}</label>
                                <input type="color" value="red" v-model="buttonColor"/>
                                <button @click="clkBtnColAsTheme()">{{ $t('widgetmaker_button_color_use_theme') }}</button>
                            </div>
                            <div class="form-group">
                                <label>{{ $t('widgetmaker_caption_label') }}</label>
                                <input type="hidden" :value="$t('widgetmaker_caption_default')" id="widgetmaker_caption_default"/>
                                <input type="text" v-model="buttonCaption"/>
                            </div>
                            <p>
                                {{ $t('widgetmaker_preview_button') }}
                            </p>
                            <button type="submit" class="btn btn-primary btn-block" :style="`background-color: ${buttonColor}`">
                                <span>{{buttonCaption}}</span></button>
                        </div>

                        <!-- /.col-* -->
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="overview">
                                <h2>{{ $t('widgetmaker_code_head') }}</h2>
                            </div>
                            <textarea id="textarea" style="width: 100%;" v-model="widgetCode"></textarea>
                            <button @click="clkCopy()">{{ $t('widgetmaker_code_copy') }}</button>
                            <p>{{ $t('widgetmaker_code_hint') }}
                            </p>
                        </div>
                    </div>


                </div>
            </div>
        </div>
    </page>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import { config } from '../../static/campsite-ui-config'

import Page from '@/components/utilities/Page'
import Blue from '@/components/theme/Blue'
import Red from '@/components/theme/Red'
import Green from '@/components/theme/Green'

export default {
  name: 'WidgetMaker',
  components: { Page, Blue, Red, Green },
  data () {
    return {
      landingLanguage: 'auto',
      landingTheme: 'blue',
      themes: [
        { name: 'blue', color: '#003399' },
        { name: 'red', color: '#991111' },
        { name: 'green', color: '#169919' },
      ],
      buttonColor: '#003399',
      buttonCaption: '...',
      defCap: true,
    }
  },
  methods: {
    ...mapMutations(['setJail']),
    clkTheme (t) {
      console.log('theme clk', t)
      this.landingTheme = t
    },
    clkCopy () {
      let textarea = document.getElementById('textarea')
      textarea.select()
      document.execCommand('copy')
    },
    clkBtnColAsTheme () {
      this.buttonColor = this.themes.find((e) => { return e.name === this.landingTheme }).color
    },
  },
  computed: {
    ...mapGetters(['jail', 'languages']),
    langPrefix () {
      if (this.landingLanguage === 'auto') return ''
      return this.landingLanguage + '/'
    },
    landingURL () {
      return `${config.uiURL}${this.langPrefix}booking/${this.$route.params.campsiteid}/?theme=${this.landingTheme}`
    },
    widgetCode () {
      return `<script async src="${config.uiURL}static/widget/b.js" cat-widget="1" cap="${this.buttonCaption}" campsite="${this.$route.params.campsiteid}" ` +
        `colorButton="${this.buttonColor}" theme="${this.landingTheme}" lang="${this.landingLanguage}" >` + '</sc' + 'ript>'
    }
  },
  created () {
    this.setJail(true)
  },
  mounted () {
    var vm = this
    setTimeout(function () {
      vm.buttonCaption = document.getElementById('widgetmaker_caption_default').value
    }, 800)
  },
}
</script>

<style scoped>
    @import '../../static/widget/b.css';

    .colorPicker {
        float: left;
        padding: 0px;
        margin: 6px;
        width: 30px;
        height: 30px;
        font-size: 0;
        border: 5px solid white;
    }
    .selPicker {
        border: 5px solid orange;
    }
</style>



// WEBPACK FOOTER //
// src/components/WidgetMaker.vue